import $ from "jquery";
import ko from "knockout";
import register from "flow/knockout/register";
import Component from "flow/Component";
import globalNotificationsHtml from "flow/viewModels/PersistentNotifications.html";
import { globalPersistentNotifications } from "flow/stores/globalPersistentNotificationStore";

register.registerKnockoutBinding("notifications", {
    init: function (element, valueAccessor) {
        const $containerElement = $("<div></div>");
        const containerElement = $containerElement[0];
        ko.virtualElements.prepend(element, containerElement);

        const componentObs = valueAccessor();

        let currentComponent = componentObs();

        const handleComponentChange = function (newComponent: Component) {
            currentComponent = newComponent;

            if (newComponent === null || newComponent === undefined) {
                ko.cleanNode(containerElement);
                $containerElement.html("");
                return;
            }

            newComponent.load().done(function () {
                // Abort if component has changed while we were loading
                if (newComponent === currentComponent) {
                    ko.cleanNode(containerElement);

                    if (!!newComponent.manifest.notificationsViewUrl) {
                        $containerElement.html(newComponent.notificationsHtml());
                        ko.applyBindings(newComponent.viewModel(), containerElement);

                        newComponent.onNotificationsViewAttached(containerElement);
                    } else {
                        $containerElement.html(globalNotificationsHtml);
                        ko.applyBindings({ persistentNotifications: globalPersistentNotifications }, containerElement);
                    }
                }
            });
        };

        componentObs.subscribe(handleComponentChange);

        if (componentObs()) {
            handleComponentChange(componentObs());
        }

        return { controlsDescendantBindings: true };
    }
});
